import * as React from 'react';
import * as RadixTooltip from '@radix-ui/react-tooltip';
import { cx } from 'class-variance-authority';

export type TooltipProviderProps = RadixTooltip.TooltipProviderProps;

export function TooltipProvider(props: TooltipProviderProps) {
  const { delayDuration = 300, ...rest } = props;
  return <RadixTooltip.Provider delayDuration={delayDuration} {...rest} />;
}

const TooltipRoot = RadixTooltip.Root;

const TooltipTrigger = RadixTooltip.Trigger;

export type TooltipContentProps = RadixTooltip.TooltipContentProps & {
  tootipContentClassName?: string;
  tootipArrowClassName?: string;
};

function TooltipContent(props: TooltipContentProps) {
  const {
    className,
    children,
    sideOffset = 6,
    collisionPadding = 8,
    tootipContentClassName,
    tootipArrowClassName,
    ...rest
  } = props;

  return (
    <RadixTooltip.Portal>
      <RadixTooltip.Content
        className={cx(
          'shadow-tooltip z-20 rounded border-blue-300 bg-blue-1000 font-medium text-white hover:border-purple-500 hover:shadow-purple-500 ',
          className
        )}
        sideOffset={sideOffset}
        collisionPadding={collisionPadding}
        {...rest}
      >
        <div
          className={cx(
            'inline-block rounded-[3px] bg-black px-4 py-2',
            tootipContentClassName
          )}
        >
          {children}
        </div>
        <RadixTooltip.Arrow
          className={cx('-m-1', tootipArrowClassName)}
          width={18}
          height={9}
        />
      </RadixTooltip.Content>
    </RadixTooltip.Portal>
  );
}

export type TooltipProps = RadixTooltip.TooltipContentProps &
  RadixTooltip.TooltipProps & {
    asChild?: boolean;
    children?: React.ReactNode;
    // eslint-disable-next-line
    content?: any;
  };

// eslint-disable-next-line
export function Tooltip(props: any) {
  const {
    children,
    content,
    asChild,
    open,
    defaultOpen,
    onOpenChange,
    delayDuration,
    ...rest
  } = props;
  return (
    <TooltipRoot {...{ open, defaultOpen, onOpenChange, delayDuration }}>
      <TooltipTrigger asChild={asChild}>{children}</TooltipTrigger>
      <TooltipContent {...rest}>{content}</TooltipContent>
    </TooltipRoot>
  );
}

export const TooltipParts = {
  TooltipProvider,
  TooltipRoot,
  TooltipTrigger,
  TooltipContent,
};
